module.exports = __webpack_public_path__ + "img/brand.836bab6e.png";